import React from 'react';
// import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Button from '../../fields/Button';

import styles from './Button.less';

const cx = classnames.bind(styles);

export default React.memo(ColumnButton);

function ColumnButton({ className, ...props }) {
  return <Button kind="secondary" className={cx('action', className)} {...props} />;
}
